import { lazy, Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Index } from './pages/Index';
import { CookiePolicy } from './pages/CookiePolicy';
import NotFound from './pages/NotFound';

// The account pages, Supabase and the toast UI stay out of the home bundle.
const AccountShell = lazy(() => import('./pages/AccountShell').then((m) => ({ default: m.AccountShell })));
const Auth = lazy(() => import('./pages/Auth'));
const ResetPassword = lazy(() => import('./pages/ResetPassword'));
const Profile = lazy(() => import('./pages/Profile'));
const ProtectedRoute = lazy(() => import('./components/ProtectedRoute'));

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        <Route
          element={
            <Suspense fallback={null}>
              <AccountShell />
            </Suspense>
          }
        >
          <Route path="/auth" element={<Auth />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
